module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a54e98269f78b67e2036168fced9b070.svg";